import React from "react";
import { AppBar, Toolbar, Box, Container } from "@mui/material";
import "../../styles/header.css";
import logo from "../../assets/images/main_logo.png";

export default function Header() {
  return (
    <AppBar position="static" elevation={0} className="header">
      <Container maxWidth="lg">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "center",
            height: { xs: "90px", sm: "130px", md: "160px" },
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="App Logo"
            className="logo"
            sx={{
              width: { xs: "180px", sm: "200px", md: "250px" },
              height: "auto",
            }}
          />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
